import ChatAction from "@/chatbot-library/ChatAction"
import moment from "moment"

class ChatCalendar extends ChatAction {
  get name() {
    return "calendar"
  }

  getResponseContent(value) {
    return moment(value).format("DD MMMM YYYY")
  }
}

export default ChatCalendar